import { Level, Attitude } from 'src/tabs/models/SkillsInterfaces';
import {
  SkillsBottomContainerMobile,
  SkillsLevelRadioGroupContainer,
  LabelContainer,
  RadioButtonContainerMobile,
  SkillsLevelExplanationText,
  SkillsAttitudeRadioGroupContainer,
} from '../../SkillsAddPopup/styles/SkillsAddPopup.styled';
import {
  EditDividerStyle,
  RadioGroupStyled,
} from '../styles/SkillsEditPopup.styled';
import {
  AlertIcon,
  LabelStyled,
  RadioButtonStyled,
  RadioButtonWrapper,
} from '../../common/styles/common.styled';
import { SKILL_EDIT_VALIDATION_MESSAGE } from 'src/tabs/constants/Skills.constants';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { useContext } from 'react';

interface SkillBottomContainerProps {
  errorMessage: string;
  level: string;
  attitude: string;
  setLevel: React.Dispatch<React.SetStateAction<string>>;
  setAttitude: React.Dispatch<React.SetStateAction<string>>;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  attitudeCode: '759590000' | '759590001' | '759590002';
  levelCode: '759590000' | '759590001' | '759590002';
  triggerRadioButton: (optionValue: Level) => void;
}

export const SkillBottomContainer = ({
  attitude,
  errorMessage,
  level,
  setAttitude,
  setLevel,
  setErrorMessage,
  attitudeCode,
  levelCode,
  triggerRadioButton,
}: SkillBottomContainerProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  return (
    <SkillsBottomContainerMobile>
      {isMobile && <EditDividerStyle isMobile={isMobile} />}
      <SkillsLevelRadioGroupContainer>
        <LabelContainer>
          {errorMessage && !level && <AlertIcon />}
          <LabelStyled required>Level</LabelStyled>
        </LabelContainer>
        <RadioGroupStyled
          layout="horizontal"
          value={level}
          onChange={(_, newData) => {
            setLevel(newData.value);
            if (attitude === attitudeCode && newData.value === levelCode) {
              setErrorMessage(SKILL_EDIT_VALIDATION_MESSAGE);
            }
          }}
        >
          <RadioButtonContainerMobile>
            <RadioButtonWrapper>
              <RadioButtonStyled
                errorStyle={errorMessage !== '' && !level}
                value={Level.LEVEL1}
                label="Level 1"
              />
            </RadioButtonWrapper>
            <SkillsLevelExplanationText
              onClick={() => triggerRadioButton(Level.LEVEL1)}
            >
              Some theoretical and/or practicle experience with the technology.
            </SkillsLevelExplanationText>
          </RadioButtonContainerMobile>
          <RadioButtonContainerMobile>
            <RadioButtonWrapper>
              <RadioButtonStyled
                errorStyle={errorMessage !== '' && !level}
                value={Level.LEVEL2}
                label="Level 2"
              />
            </RadioButtonWrapper>
            <SkillsLevelExplanationText
              onClick={() => triggerRadioButton(Level.LEVEL2)}
            >
              Professional experience with the technology in one or two customer
              projects.
            </SkillsLevelExplanationText>
          </RadioButtonContainerMobile>
          <RadioButtonContainerMobile>
            <RadioButtonWrapper>
              <RadioButtonStyled
                errorStyle={errorMessage !== '' && !level}
                value={Level.LEVEL3}
                label="Level 3"
              />
            </RadioButtonWrapper>
            <SkillsLevelExplanationText
              onClick={() => triggerRadioButton(Level.LEVEL3)}
            >
              Extensive professional experience with the technology in multiple
              customer projects.
            </SkillsLevelExplanationText>
          </RadioButtonContainerMobile>
        </RadioGroupStyled>
      </SkillsLevelRadioGroupContainer>
      <SkillsAttitudeRadioGroupContainer>
        <LabelContainer>
          {errorMessage && !attitude && <AlertIcon />}
          <LabelStyled required>Attitude</LabelStyled>
        </LabelContainer>
        <RadioGroupStyled
          style={{
            padding: '0 0 0 0px',
          }}
          layout="horizontal"
          value={attitude}
          onChange={(_, newData) => {
            setAttitude(newData.value);
            if (newData.value === attitudeCode && level === levelCode) {
              setErrorMessage(SKILL_EDIT_VALIDATION_MESSAGE);
            }
          }}
        >
          <RadioButtonWrapper>
            <RadioButtonStyled
              errorStyle={errorMessage !== '' && !attitude}
              value={Attitude.POSITIVE}
              label="Positive"
            />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButtonStyled
              errorStyle={errorMessage !== '' && !attitude}
              value={Attitude.NEUTRAL}
              label="Neutral"
            />
          </RadioButtonWrapper>
          <RadioButtonWrapper>
            <RadioButtonStyled
              errorStyle={errorMessage !== '' && !attitude}
              value={Attitude.NEGATIVE}
              label="Negative"
            />
          </RadioButtonWrapper>
        </RadioGroupStyled>
      </SkillsAttitudeRadioGroupContainer>
    </SkillsBottomContainerMobile>
  );
};
